// extracted by mini-css-extract-plugin
export default {"container":"style_container__F6cyk","tag":"style_tag__agwIy","tagName":"style_tagName__t+4uc","tagValue":"style_tagValue__n3T9t"};